<h1 mat-dialog-title fxLayoutAlign="center">{{ title | transloco }}</h1>
<div mat-dialog-content>
  {{ message }}
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button type="button" (click)="cancel()">{{ cancelLabel | transloco }}</button>
  <button mat-flat-button type="button" color="primary" (click)="confirm()">{{ confirmationLabel | transloco }}</button>
</div>